import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { Organization } from "../model/OrganizationSuccessResponse";

export const GET_ORGANIZATION_SUCCESS = "ORGANIZATION:GET_ORANIZATION_SUCCESS";

export interface GetOrganizationSuccessAction extends Action {
  type: typeof GET_ORGANIZATION_SUCCESS;
  organization: OrganizationKeyName;
  data: Organization;
}

export const getOrganizationSuccessAction = (
  organization: OrganizationKeyName,
  data: Organization
): GetOrganizationSuccessAction => ({
  type: GET_ORGANIZATION_SUCCESS,
  organization,
  data,
});
